import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\RenderCatalogItemsController::__invoke
* @see app/Http/Controllers/Item/RenderCatalogItemsController.php
* @route '/api/item/render/catalog'
*/
const RenderCatalogItemsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: RenderCatalogItemsController.url(options),
    method: 'get',
})

RenderCatalogItemsController.definition = {
    methods: ["get","head"],
    url: '/api/item/render/catalog',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\RenderCatalogItemsController::__invoke
* @see app/Http/Controllers/Item/RenderCatalogItemsController.php
* @route '/api/item/render/catalog'
*/
RenderCatalogItemsController.url = (options?: RouteQueryOptions) => {
    return RenderCatalogItemsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\RenderCatalogItemsController::__invoke
* @see app/Http/Controllers/Item/RenderCatalogItemsController.php
* @route '/api/item/render/catalog'
*/
RenderCatalogItemsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: RenderCatalogItemsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\RenderCatalogItemsController::__invoke
* @see app/Http/Controllers/Item/RenderCatalogItemsController.php
* @route '/api/item/render/catalog'
*/
RenderCatalogItemsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: RenderCatalogItemsController.url(options),
    method: 'head',
})

export default RenderCatalogItemsController